module.exports = require('./lib/index');



//////////////////
// WEBPACK FOOTER
// /~/react-hot-loader/index.js
// module id = rGbO
// module chunks = 0